import { render, staticRenderFns } from "./openInfo.vue?vue&type=template&id=3fadfb3c&scoped=true&"
import script from "./openInfo.vue?vue&type=script&lang=js&"
export * from "./openInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fadfb3c",
  null
  
)

export default component.exports